<template>
    <div class="h-full min-h-0">
        <html-code-editor
            ref="editor"
            :model-value="modelValue"
            :rows="editorRows"
            :readonly="readonly"
            :variant="variant"
            :fill="fill"
            @update:modelValue="$emit('update:modelValue', $event)"
        />

        <cms-media-drawer
            :open="drawerOpen"
            @close="drawerOpen = false"
            @insert="insertMediaSnippet"
        />
    </div>
</template>

<script>
import HtmlCodeEditor from "@/components/forms/html-code-editor";
import CmsMediaDrawer from "@/components/cms/cms-media-drawer";

export default {
    name: "CmsHtmlCodeEditor",
    components: {
        CmsMediaDrawer,
        HtmlCodeEditor,
    },
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        rows: {
            type: Number,
            default: null,
        },
        minHeight: {
            type: Number,
            default: 320,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'default',
        },
        fill: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            drawerOpen: false,
        };
    },
    computed: {
        editorRows() {
            if (this.rows && this.rows > 0) {
                return this.rows;
            }

            const estimatedRows = Math.round(this.minHeight / 18);
            return Math.max(12, estimatedRows);
        },
    },
    methods: {
        openMediaDrawer() {
            if (this.readonly) {
                return;
            }

            this.drawerOpen = true;
        },
        insertMediaSnippet(snippet) {
            this.$refs.editor?.insertAtCursor(snippet);
            this.drawerOpen = false;
        },
    },
};
</script>
